import { render, staticRenderFns } from "./Parent.vue?vue&type=template&id=504db99e&scoped=true&"
import script from "./Parent.vue?vue&type=script&lang=ts&"
export * from "./Parent.vue?vue&type=script&lang=ts&"
import style0 from "./Parent.vue?vue&type=style&index=0&id=504db99e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504db99e",
  null
  
)

export default component.exports